import dbsService from "@/services/dbs";
import store from "@/store";

// x-bks-sessionid必須
export const getDbsPark = async (id) => {
  try {
    const resp = await dbsService.apiWithSessionIdWrapper(
      "GET",
      `dbs/parks/${id}`
    );
    const storeParkData = store.getters["dbs/park"];
    store.commit("dbs/setPark", { ...storeParkData, ...resp.data });
  } catch (err) {
    console.log('ERROR"" getDbsPark()');
    throw err;
  }
};
